import React from "react";
import axios from "axios";
import moment from "moment";
import Select from "react-select";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/fontawesome-free-solid";

import { getBookingDetails } from "../../../redux/booking/booking-slice";
import { setProfileBoxAction } from "../../../redux/auth/auth-slice";

import { cn } from "../../../utils/lib";

export default function OrderPage() {
  const { id } = useParams();

  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const { bookingDetails } = useSelector((state) => state.booking);

  const [driverid, setdriverid] = React.useState("");
  const [driversForAssign, setdriversForAssign] = React.useState([]);

  const getDriversForAssign = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/drivers/getDriversForAssign`,
        {
          headers: {
            Authorization: token,
          },
          withCredentials: true,
        },
      );

      setdriversForAssign(response?.data?.drivers);
    } catch (error) {
      toast.error(error?.response?.data?.msg);
    }
  };

  React.useEffect(() => {
    getDriversForAssign();
  }, [token]);

  React.useEffect(() => {
    dispatch(
      getBookingDetails({
        bookingDetails: {},
      }),
    );

    if (token) {
      dispatch({
        type: "BOOKING_DETAILS",
        payload: {
          bookingId: id,
          token: token,
        },
      });
    }
  }, [token, dispatch, id]);

  React.useEffect(() => {
    dispatch(setProfileBoxAction({ profileBoxAction: false }));
  }, []);

  console.log("Booking Details -->", bookingDetails);

  return (
    <div
      className="py-3"
      onClick={() => {
        dispatch(setProfileBoxAction({ profileBoxAction: false }));
      }}
    >
      {/* Back Button */}
      <div className="px-3 py-3 text-white md:px-10">
        <Link
          to="/orders"
          className="rounded-full border border-slate-800 bg-slate-900 p-2"
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            className="text-white/800 h-5 w-5 cursor-pointer pt-0.5"
          />
        </Link>
      </div>

      {/* Booking Information Card */}
      <div className="px-3 py-2 scrollbar md:px-10">
        <div className="cardBorder2 borderFN">
          <div
            id="grad"
            className="grid grid-cols-1 gap-4 rounded-lg shadow-[#0f0e0e] lg:grid-cols-5 lg:pb-2"
          >
            {/* Card Headings */}
            <div className="col-span-full rounded-t-lg bg-gradient-to-r from-[#0c0c0c] via-[#444444] to-[#0c0c0c] px-6 py-2 text-xl font-semibold text-white">
              Details
            </div>

            {/* Booking Details */}
            <div className="col-span-full space-y-2 px-6 pb-2 lg:col-span-3">
              <div className="flex w-full items-center space-x-2 pb-3 text-lg font-semibold text-[#00E0FF]">
                <h2>Booking Details</h2>
              </div>
              <OrderItem label="Booking ID" value={bookingDetails?.bookingId} />
              <OrderItem
                label="Booking Type"
                value={bookingDetails?.bookingType}
              />
              <OrderItem
                label="Flight No"
                value={
                  bookingDetails?.passengerDetails?.flightNumber !== "" ? (
                    bookingDetails?.passengerDetails?.flightNumber
                  ) : (
                    <>
                      <hi className="font-medium text-[#fb4156]">
                        FLIGHT NOT ASSIGNED
                      </hi>
                    </>
                  )
                }
              />
              <OrderItem
                label="Booking Status"
                value={bookingDetails?.bookingStatus}
              />
              <OrderItem
                label="Price"
                value={
                  bookingDetails?.purchasePrice +
                  " " +
                  bookingDetails?.purchaseCurrency
                }
              />
              <OrderItem
                label="Vehicle Type"
                value={bookingDetails?.vehicleDetails?.categoryType}
              />
            </div>

            {/* Passenger Details */}
            <div className="col-span-full space-y-2 max-lg:px-6 lg:col-span-2">
              <h2 className="flex w-full items-center space-x-2 pb-3 text-lg font-semibold text-[#00E0FF]">
                Passenger Details
              </h2>
              <OrderItem
                label="Passenger Name"
                value={
                  bookingDetails?.passengerDetails?.firstName +
                  " " +
                  bookingDetails?.passengerDetails?.lastName
                }
              />
              <OrderItem
                label="Contact No"
                value={
                  bookingDetails?.passengerDetails?.code +
                  " " +
                  bookingDetails?.passengerDetails?.phone
                }
              />
              <OrderItem
                label="Passenger Count"
                value={bookingDetails?.passenger}
              />
              <OrderItem
                label="Affiliate Note"
                value={
                  bookingDetails?.affiliateNote
                    ? bookingDetails?.affiliateNote
                    : "--"
                }
              />
            </div>

            {/* View Tracking */}
            <div className="col-span-full px-6">
              <Link
                className="inline-flex rounded-md bg-white px-5 py-1.5 text-center text-sm font-bold text-slate-700 shadow-sm hover:bg-slate-200"
                to="https://www.drivado.com"
                target="_blank"
              >
                View Tracking
              </Link>
            </div>

            {/* Pickup & Drop off Details */}
            <div className="col-span-full px-6 lg:col-span-3">
              <div className="flex w-full items-center space-x-2 pb-3 text-lg font-semibold text-[#00E0FF]">
                <h2>Pick Up & Drop off Details</h2>
              </div>
              <div className="space-y-2 pt-2">
                <OrderItem
                  label="Pick Up"
                  value={bookingDetails?.source?.placename}
                />

                {bookingDetails?.destination?.placename && (
                  <OrderItem
                    label="Drop Off"
                    value={bookingDetails?.destination?.placename}
                  />
                )}
                <OrderItem
                  label="Date & Time "
                  value={
                    bookingDetails?.travelDate
                      ? moment(
                          bookingDetails?.travelDate?.split("T")[0],
                        ).format("DD-MM-YYYY") +
                        " | " +
                        bookingDetails?.travelTime
                      : ""
                  }
                />
                <OrderItem
                  label="Duration"
                  value={
                    bookingDetails?.durationForAffiliate
                      ? bookingDetails?.durationForAffiliate
                      : "--"
                  }
                />
                {bookingDetails?.passengerDetails?.specialRequest && (
                  <OrderItem
                    label="Special Request"
                    value={bookingDetails?.passengerDetails?.specialRequest}
                  />
                )}
              </div>
            </div>

            {/* Driver Details */}
            <div className="col-span-full space-y-2 px-6 lg:col-span-2 lg:px-0">
              <div className="w-full items-center">
                <div className="w-full pb-3 text-lg font-semibold text-[#00E0FF]">
                  Driver&nbsp;Details
                </div>
                <div className="flex items-center rounded-full py-2 lg:space-x-0">
                  <div className="w-40 text-sm font-semibold text-white md:text-base 2xl:w-[12rem]">
                    Assign&nbsp;driver
                  </div>

                  <Select
                    className="w-32 rounded-lg border border-slate-300 bg-white text-black focus:border-none focus:outline-none"
                    options={driversForAssign.map((driver) => {
                      return {
                        value: driver,
                        label: driver?.name,
                      };
                    })}
                    onChange={(e) => {
                      setdriverid(e.value?._id);
                    }}
                  />
                  <div
                    onClick={() => {
                      dispatch({
                        type: "ASSIGN_DRIVER",
                        payload: {
                          body: {
                            bookingId: id,
                            driverId: driverid,
                          },
                          token: token,
                        },
                      });
                    }}
                    className="cursor-pointer rounded-sm px-2 py-0.5 text-base font-semibold text-teal-500"
                  >
                    Save
                  </div>
                </div>
              </div>

              {bookingDetails?.driverDetails ? (
                <div className="space-y-2 pt-2">
                  <OrderItem
                    label="Driver Name"
                    value={bookingDetails?.driverDetails?.name}
                    loading={!bookingDetails?.driverDetails?.name}
                  />
                  <OrderItem
                    label="Contact Number"
                    value={
                      bookingDetails?.driverDetails?.countryCode &&
                      bookingDetails?.driverDetails?.contactNumber &&
                      bookingDetails?.driverDetails?.countryCode +
                        " " +
                        bookingDetails?.driverDetails?.contactNumber
                    }
                  />
                  <OrderItem
                    label="Car Plate Number"
                    value={
                      bookingDetails?.driverDetails?.carPlateNo
                        ? bookingDetails?.driverDetails?.carPlateNo
                        : "--"
                    }
                  />
                  <OrderItem
                    label="License Number"
                    value={
                      bookingDetails?.driverDetails?.carLicenseNo
                        ? bookingDetails?.driverDetails?.carLicenseNo
                        : "--"
                    }
                  />
                </div>
              ) : (
                <div className="space-y-2 pt-2"></div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const OrderItem = React.memo(
  ({
    label,
    value,
    loading, // force skeleton if true
    labelWidth = "w-32 md:w-40", // customize label column width
    className = "", // optional wrapper classes
  }) => {
    const isEmpty = (v) => v === null || v === undefined || v === "";
    const showSkeleton = loading ?? isEmpty(value);

    return (
      <div
        className={cn(
          "grid grid-cols-[10rem_1fr] 2xl:grid-cols-[12rem_1fr]",
          className,
        )}
      >
        <div
          className={`${labelWidth} text-sm font-semibold text-white md:text-base`}
        >
          {label}:
        </div>
        {showSkeleton && (
          <div
            role="status"
            aria-live="polite"
            aria-busy="true"
            className="animate-pulse md:flex md:items-center md:space-x-8"
          >
            <div className="h-2.5 w-48 rounded-full bg-gray-400 dark:bg-gray-700" />
          </div>
        )}

        {!showSkeleton && (
          <div className="text-base font-normal text-gray-300">{value}</div>
        )}
      </div>
    );
  },
);
